import { render, staticRenderFns } from "./EditableAvatar.vue?vue&type=template&id=098f926a&"
import script from "./EditableAvatar.vue?vue&type=script&lang=js&"
export * from "./EditableAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports